import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ControlsModule } from 'app/controls/controls.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { ActionBarComponent
       } from './placeholder/overlays/action-bar/action-bar.component';
import { ActionBarDirective
       } from './placeholder/overlays/action-bar/action-bar.directive';
import { QualityRatingIconComponent
       } from './placeholder/overlays/quality-rating-icon/quality-rating-icon.component'; // tslint:disable-line
import { QualityRatingIconDirective
       } from './placeholder/overlays/quality-rating-icon/quality-rating-icon.directive'; // tslint:disable-line
import { PlaceholderContentService
       } from './placeholder/placeholder-content.service';
import { PlaceholderService } from './placeholder/placeholder.service';
import { StageComponent } from './stage.component';
import { StageService } from './stage.service';
import { SVGValidationService } from './svg-validation.service';

import { TranslationModule } from 'core/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    MatModule,
    ImageSelectionDirectiveModule,
    TranslationModule,
  ],
  declarations: [
    ActionBarComponent,
    ActionBarDirective,
    QualityRatingIconComponent,
    QualityRatingIconDirective,
    StageComponent,
  ],
  exports: [
    StageComponent,
  ],
  entryComponents: [
      ActionBarComponent,
      QualityRatingIconComponent,
  ],
  providers: [
    StageService, SVGValidationService, PlaceholderService,
    PlaceholderContentService
  ]
})
export class StageModule { }



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/stage.module.ts